import Image from "next/image"

export const illustrationRegistry = {
  "catalog-pending": { alt: "새로운 혜택을 준비 중인 선물 상자", src: "/assets/cashhub/illustrations/catalog-pending-gift.webp" },
  "empty-balance": { alt: "포인트가 도착하기를 기다리는 CashHub 지갑", src: "/assets/cashhub/illustrations/zero-balance-wallet.webp" },
  "empty-history": { alt: "첫 이용 내역을 기다리는 빈 타임라인", src: "/assets/cashhub/illustrations/empty-history-timeline.webp" },
  "empty-notifications": { alt: "모든 소식을 확인한 알림 종", src: "/assets/cashhub/illustrations/empty-notifications-bell.webp" },
  "empty-vouchers": { alt: "발급된 상품권을 확인하는 휴대폰과 티켓", src: "/assets/cashhub/illustrations/empty-vouchers-phone-ticket.webp" },
  login: { alt: "안전한 Google 계정 로그인을 안내하는 화면", src: "/assets/cashhub/illustrations/secure-login.webp" },
  recovery: { alt: "끊어진 연결을 다시 잇는 복구 경로", src: "/assets/cashhub/illustrations/connection-recovery.webp" },
  support: { alt: "안내를 주고받는 고객지원 대화", src: "/assets/cashhub/illustrations/support-chat.webp" },
} as const

export type IllustrationKind = keyof typeof illustrationRegistry

const vividIllustrations: Readonly<Record<IllustrationKind, string>> = {
  "catalog-pending": "/assets/cashhub/vivid-violet/voucher-v2.webp",
  "empty-balance": "/assets/cashhub/vivid-violet/empty-activity-v2.webp",
  "empty-history": "/assets/cashhub/vivid-violet/empty-activity-v2.webp",
  "empty-notifications": "/assets/cashhub/vivid-violet/empty-activity-v2.webp",
  "empty-vouchers": "/assets/cashhub/vivid-violet/voucher-v2.webp",
  login: "/assets/cashhub/vivid-violet/secure-login-v2.webp",
  recovery: "/assets/cashhub/vivid-violet/empty-activity-v2.webp",
  support: "/assets/cashhub/vivid-violet/support-v2.webp",
}

export const Illustration = ({ decorative = false, kind }: { readonly decorative?: boolean; readonly kind: IllustrationKind }) => {
  const illustration = illustrationRegistry[kind]
  const source = vividIllustrations[kind]
  return (
    <span className="cashhub-illustration-frame">
      <Image alt={decorative ? "" : illustration.alt} className="cashhub-illustration" height={720} priority={kind === "login"} src={source} unoptimized width={720} />
    </span>
  )
}
